// extracted by mini-css-extract-plugin
module.exports = {"thead":"test_thead__224xB","td_value":"test_td_value__3ZUej","td_value_sel":"test_td_value_sel__3Da-p","input_value":"test_input_value__TFiaC","hint":"test_hint__3dLrD"};